module.exports = __webpack_public_path__ + "static/media/chatLoader.2c9db73f.gif";